import { ReactElement } from 'react';
import { Logo as CoreLogo } from '@client/common/components/Logo';

export const Logo = ({ className }: { className?: string }): ReactElement => (
  <CoreLogo shop="Jamei" className={className} />
);
